import { SET_RENEWAL_BIKE } from 'pages/Renewal/actions/renewalActions';
import { RenewalBikeActionType } from '../types/actions';
import { ReservationDetailsType } from 'pages/Resabike/types/resabike';

type RenewalBikeState = {
  reservationDetails: ReservationDetailsType | null;
};

const initialState: RenewalBikeState = {
  reservationDetails: null,
};

const renewalBikeReducer = (
  state: RenewalBikeState = initialState,
  action: RenewalBikeActionType
): RenewalBikeState => {
  switch (action.type) {
    case SET_RENEWAL_BIKE:
      const { reservationDetails } = action.payload;

      return {
        ...state,
        reservationDetails,
      };

    default:
      return state;
  }
};

export default renewalBikeReducer;
